import { baseURL } from '../httpService/API';
import { hMacAjax } from 'grt-tool-lib-front';

export const getMenus = (sideId) => {
    return hMacAjax.get(
        baseURL + '/apaas-system-service/resource/v1/menus',
        {},
        {
            headers: {
                side: sideId
            }
        }
    );
};
//获取按钮权限集合
export const getOpers = () => {
    return hMacAjax.get(baseURL + '/apaas-system-service/resource/v1/button');
};
//获取当前租户的拥有的端列表
export const getSide = () => {
    return hMacAjax.get(baseURL + '/apaas-system-service/side/v1/list');
};
